import { render, staticRenderFns } from "./DetailDataList.vue?vue&type=template&id=4a12e58e&scoped=true&"
import script from "./DetailDataList.vue?vue&type=script&lang=js&"
export * from "./DetailDataList.vue?vue&type=script&lang=js&"
import style0 from "./DetailDataList.vue?vue&type=style&index=0&id=4a12e58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12e58e",
  null
  
)

export default component.exports